export default "__VITE_ASSET__cfecf574__"